/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Log entry for workspace recovery errors
 * @export
 * @interface WorkspaceRecoveryErrorLog
 */
export interface WorkspaceRecoveryErrorLog {
    /**
     * Unique identifier for this error log entry
     * @type {number}
     * @memberof WorkspaceRecoveryErrorLog
     */
    id?: number;
    /**
     * The ID of the workspace that encountered the error
     * @type {number}
     * @memberof WorkspaceRecoveryErrorLog
     */
    workspaceId?: number;
    /**
     * The error message describing what went wrong
     * @type {string}
     * @memberof WorkspaceRecoveryErrorLog
     */
    errorMessage?: string;
    /**
     * The type or category of the error
     * @type {string}
     * @memberof WorkspaceRecoveryErrorLog
     */
    errorType?: string;
    /**
     * Timestamp when the error was logged
     * @type {string}
     * @memberof WorkspaceRecoveryErrorLog
     */
    createdTime?: string;
}

/**
 * Check if a given object implements the WorkspaceRecoveryErrorLog interface.
 */
export function instanceOfWorkspaceRecoveryErrorLog(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WorkspaceRecoveryErrorLogFromJSON(json: any): WorkspaceRecoveryErrorLog {
    return WorkspaceRecoveryErrorLogFromJSONTyped(json, false);
}

export function WorkspaceRecoveryErrorLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceRecoveryErrorLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'workspaceId': !exists(json, 'workspaceId') ? undefined : json['workspaceId'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'errorType': !exists(json, 'errorType') ? undefined : json['errorType'],
        'createdTime': !exists(json, 'createdTime') ? undefined : json['createdTime'],
    };
}

export function WorkspaceRecoveryErrorLogToJSON(value?: WorkspaceRecoveryErrorLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'workspaceId': value.workspaceId,
        'errorMessage': value.errorMessage,
        'errorType': value.errorType,
        'createdTime': value.createdTime,
    };
}

